import React from "react"
import {observer} from "mobx-react"
import {injectIntl} from "react-intl"

import {Grid, Container} from "@material-ui/core"
import XsButton from "../xsButton/xsButton"
import XsConfirmationDialog from "../xsDialog/xsConfirmationDialog"

import RouterStore from "../../store/RouterStore"

import {logout} from "../../helpers/actions"

function XsHeader() {
	return (
		<div className="main_header">
			<Container maxWidth="lg">
				<Grid container alignItems="center" className="pt-2 pb-2">
					<Grid item container xs justify="space-between" alignItems="center">
						<Grid item container xs spacing={4}>
							<Grid item>
								<XsButton
									icon={<i className="fas fa-file-signature fa-2x"></i>}
									style={RouterStore.location.pathname !== "/requests" ? {color: "#80989E"} : {}}
									variant="text"
									text="Žiadosti" //{<FormattedMessage id="Common.label.requests" />}
									onClick={() => {
										RouterStore.push("/requests")
									}}
								/>
							</Grid>
							<Grid item>
								<XsButton
									icon={<i className="fas fa-euro-sign fa-2x"></i>}
									style={RouterStore.location.pathname !== "/allocations" ? {color: "#80989E"} : {}}
									variant="text"
									text="Alokácie"
									onClick={() => {
										RouterStore.push("/allocations")
									}}
								/>
							</Grid>
							<Grid item>
								<XsButton
									icon={<i className="fas fa-cog fa-2x"></i>}
									style={RouterStore.location.pathname !== "/settings" ? {color: "#80989E"} : {}}
									variant="text"
									text="Nastavenia"
									onClick={() => {
										RouterStore.push("/settings")
									}}
								/>
							</Grid>
						</Grid>
						<Grid item>
							<XsButton
								icon={<i className="fas fa-sign-out-alt fa-2x"></i>}
								className="xs-primary"
								text="Odhlásiť sa"
								onClick={() => {
									logout()
								}}
							/>
						</Grid>
					</Grid>
				</Grid>
			</Container>
			<XsConfirmationDialog
				name="xsCloseRequestFormOverLogout"
				text="Are you sure you want to leave and discard recent changes?"
				confirmBtn={{
					icon: <i className="fal fa-check" />,
					text: "Common.btn.yes"
				}}
				cancelBtn={{
					icon: <i className="fal fa-times" />,
					text: "Common.btn.no"
				}}
				onConfirmation={() => {
					logout()
				}}
			/>
		</div>
	)
}

export default injectIntl(observer(XsHeader))

